<template>
  <div v-if="isFetchingData" class="deliverySetting-loading">
    <b-spinner variant="danger" />
  </div>
  <div v-else class="settings">
    <div class="settings-main">
      <h4 class="setTittle">
        <span>Delivery Settings</span>
      </h4>
      <div class="input-a mt-4 shadowBox">
        <p>First-tire delivery method</p>
        <div class="deliMethod">
          <div class="speedy">
            <h4>Mr Speedy</h4>
            <b-form-checkbox
              v-model="isMrSpeedy"
              class="speedyCheckbox"
              @change="changeSpeedyStatus($event)"
            />
          </div>
          <div class="shipper">
            <h4>Shipper ID</h4>
            <b-form-checkbox
              v-model="isShipperID"
              class="speedyCheckbox"
              @change="changeShipperStatus($event)"
            />
          </div>
        </div>
        <small v-if="isShowVerify">
          The First-tire delivery method field is required
        </small>
      </div>
      <div class="input-b mt-4 shadowBox">
        <p>Distance</p>
        <b-input-group append="KM">
          <b-form-input
            v-model.number="obj.distance"
            v-validate="'required|alpha_num'"
            type="text"
            placeholder="please enter Distance E.g 5 KM"
            name="distance"
            :class="{'form-error': errors.first('distance')}"
          />
        </b-input-group>
        <small>{{ errors.first('distance') }}</small>
      </div>
      <div class="input-c mt-4 shadowBox">
        <p>Response Time</p>
        <b-input-group append="Sec">
          <b-form-input
            v-model.number="obj.response_time"
            v-validate="'required|alpha_num'"
            type="text"
            placeholder="please enter Response Time E.g 30 second"
            name="Response Time"
            :class="{'form-error': errors.first('Response Time')}"
          />
        </b-input-group>
        <small>{{ errors.first('Response Time') }}</small>
      </div>
      <div class="buttons">
        <b-button class="reset mr-5" @click="reset">
          Reset
        </b-button>
        <b-button class="allow" @click="saveData">
          Save
        </b-button>
      </div>
      <b-button ref="showModel" v-b-modal.modal-1 style="display: none;" />
      <b-modal id="modal-1">
        <p class="my-4 center">
          {{ saveMessage }}
        </p>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { getResponseToMTHForNewPort } from '@/utils/helpers';
import constants from '@/utils/constants';

export default {
  data() {
    return {
      obj: {
        service_provider: '',
        distance: null,
        response_time: null
      },
      isMrSpeedy: false,
      isShipperID: false,
      isShowVerify: false,
      saveMessage: null
    };
  },

  computed: {
    settingItems() {
      return this.$store.getters.GetSettingItem;
    },
    isFetchingData() {
      return this.$store.getters.GetFetchingData;
    }
  },

  watch: {
    settingItems() {
      if (JSON.stringify(this.settingItems) !== '{}') {
        this.obj = this.settingItems;
        if (this.settingItems.service_provider === 'mrspeedy') {
          this.isMrSpeedy = true;
        } else {
          this.isShipperID = true;
        }
      }
    }
  },

  mounted() {
    this.load();
  },

  methods: {
    load() {
      this.$store.dispatch('GetDeliverySetting');
    },

    saveData() {
      this.isSaveShow = true;
      if (this.isMrSpeedy === false && this.isShipperID === false) {
        this.isShowVerify = true;
      }
      this.$validator.validate().then(valid => {
        if (valid) {
          this.$store
            .dispatch('CreatedDeliverySetting', this.obj)
            .then(res => {
              getResponseToMTHForNewPort(
                res.data,
                this.$swal,
                constants.RECORD_IS_CREATED
              );
            })
            .catch(error => {
              this.$swal(
                constants.SOMETHING_WROING,
                error,
                constants.STATUS_ERROR
              );
            });
        }
      });
    },

    reset() {
      this.obj = {
        service_provider: '',
        distance: '',
        response_time: ''
      };
      this.isMrSpeedy = false;
      this.isShipperID = false;
      this.isShowVerify = true;
    },

    changeSpeedyStatus(e) {
      this.isShipperID = false;
      if (e) {
        this.obj.service_provider = 'mrspeedy';
        this.isShowVerify = false;
      } else {
        this.obj.service_provider = '';
        this.isShowVerify = true;
      }
    },

    changeShipperStatus(e) {
      this.isMrSpeedy = false;
      if (e) {
        this.obj.service_provider = 'shipperid';
        this.isShowVerify = false;
      } else {
        this.obj.service_provider = '';
        this.isShowVerify = true;
      }
    }
  }
};
</script>
